// PGSpeechData
import React, { FC } from 'react';
import SpeechCard from '../../components/SpeechCard';
import styles from './PGSpeech.module.scss';

interface Props {
  SpeechCardList: Array<{ [key: string]: string }>;
}
const PGSpeech: FC<Props> = (props) => {
  const { SpeechCardList } = props;

  return (
    <section className={styles['pg-speech-box']}>
      <div className={styles['speech-list-box']}>
        {SpeechCardList?.map((item, index) => (
          <div key={index} className={styles['speech-card-item']}>
            <SpeechCard SpeechCardData={item} />
          </div>
        ))}
      </div>
    </section>
  );
};
PGSpeech.defaultProps = {};

PGSpeech.displayName = 'PGSpeech';
export default PGSpeech;
